import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getMetersPerVerticalUnitForSR as e } from "../../../core/unitUtils.js";
import { equals as t } from "../../../geometry/support/spatialReferenceUtils.js";
import r, { hasGeometry as o } from "../../../layers/graphics/OptimizedFeature.js";
import i from "../../../layers/graphics/OptimizedFeatureSet.js";
import s from "../../../layers/graphics/OptimizedGeometry.js";
var n = ["esriGeometryPoint", "esriGeometryMultipoint", "esriGeometryPolyline", "esriGeometryPolygon"];

var a = /*#__PURE__*/function () {
  function a(e) {
    _classCallCheck(this, a);

    this.options = e, this.geometryTypes = n, this._coordinatePtr = 0, this._vertexDimension = 0;
  }

  _createClass(a, [{
    key: "createFeatureResult",
    value: function createFeatureResult() {
      return new i();
    }
  }, {
    key: "prepareFeatures",
    value: function prepareFeatures(e) {
      this._vertexDimension = 2, e.hasZ && this._vertexDimension++, e.hasM && this._vertexDimension++;
    }
  }, {
    key: "finishFeatureResult",
    value: function finishFeatureResult(r) {
      if (!r || !r.features || !r.hasZ || !this.options.sourceSpatialReference || !r.spatialReference || t(r.spatialReference, this.options.sourceSpatialReference) || r.spatialReference.vcsWkid) return;
      var i = e(this.options.sourceSpatialReference) / e(r.spatialReference);

      if (1 !== i) {
        var _iterator = _createForOfIteratorHelper(r.features),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e = _step.value;
            if (!o(_e)) continue;
            var _t = _e.geometry.coords;

            for (var _e2 = 2; _e2 < _t.length; _e2 += 3) {
              _t[_e2] *= i;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "addFeature",
    value: function addFeature(e, t) {
      e.features.push(t);
    }
  }, {
    key: "createFeature",
    value: function createFeature() {
      return new r();
    }
  }, {
    key: "createSpatialReference",
    value: function createSpatialReference() {
      return {
        wkid: 0
      };
    }
  }, {
    key: "createGeometry",
    value: function createGeometry() {
      return new s();
    }
  }, {
    key: "addField",
    value: function addField(e, t) {
      e.fields.push(t);
    }
  }, {
    key: "allocateCoordinates",
    value: function allocateCoordinates(e) {
      e.coords.length = e.lengths.reduce(function (e, t) {
        return e + t;
      }, 0) * this._vertexDimension, this._coordinatePtr = 0;
    }
  }, {
    key: "addCoordinate",
    value: function addCoordinate(e, t) {
      e.coords[this._coordinatePtr++] = t;
    }
  }, {
    key: "addCoordinatePoint",
    value: function addCoordinatePoint(e, t) {
      e.coords.push(t);
    }
  }, {
    key: "addLength",
    value: function addLength(e, t) {
      e.lengths.push(t);
    }
  }, {
    key: "addQueryGeometry",
    value: function addQueryGeometry(e, t) {
      e.queryGeometry = t.queryGeometry, e.queryGeometryType = t.queryGeometryType;
    }
  }, {
    key: "createPointGeometry",
    value: function createPointGeometry() {
      return new s();
    }
  }]);

  return a;
}();

export { n as OPTIMIZED_GEOMETRY_TYPES, a as OptimizedFeatureSetParserContext };